import React, { useState } from 'react';
import { Hash, Plus, Check } from 'lucide-react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const commonVariables = [
  { value: 'customer_name', label: 'Customer Name' },
  { value: 'company_name', label: 'Company Name' },
  { value: 'appointment_title', label: 'Appointment Title' },
  { value: 'appointment_date', label: 'Appointment Date' },
  { value: 'appointment_time', label: 'Appointment Time' },
  { value: 'service_name', label: 'Service Name' },
  { value: 'location', label: 'Location' },
  { value: 'invoice_number', label: 'Invoice Number' },
  { value: 'total_amount', label: 'Total Amount' },
  { value: 'due_date', label: 'Due Date' },
];

export default function VariableInserter({ variables, onInsert }) {
  const [customVariable, setCustomVariable] = useState('');
  const [showCustom, setShowCustom] = useState(false);

  const handleInsert = (variable) => {
    onInsert(variable);
    navigator.clipboard?.writeText(`{{${variable}}}`);
  };

  const handleCustomInsert = () => {
    if (customVariable?.trim()) {
      const varName = customVariable?.trim()?.toLowerCase()?.replace(/\s+/g, '_');
      onInsert(varName);
      navigator.clipboard?.writeText(`{{${varName}}}`);
      setCustomVariable('');
      setShowCustom(false);
    }
  };

  return (
    <div>
      <h3 className="text-sm font-semibold text-gray-900 mb-3 flex items-center gap-2">
        <Hash className="w-4 h-4" />
        Variables
      </h3>
      <div className="space-y-1 max-h-[300px] overflow-y-auto">
        {commonVariables?.map((variable) => {
          const isUsed = variables?.includes(variable?.value);
          
          return (
            <button
              key={variable?.value}
              onClick={() => handleInsert(variable?.value)}
              className={`w-full text-left p-2 rounded-lg text-sm transition-all ${
                isUsed
                  ? 'bg-green-50 text-green-700 border border-green-200' :'hover:bg-gray-100 text-gray-700'
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="font-medium">{variable?.label}</span>
                {isUsed && <Check className="w-4 h-4" />}
              </div>
              <span className="text-xs text-gray-500 font-mono">
                {`{{${variable?.value}}}`}
              </span>
            </button>
          );
        })}
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200">
        {showCustom ? (
          <div className="space-y-2">
            <Input
              placeholder="custom_variable"
              value={customVariable}
              onChange={(e) => setCustomVariable(e?.target?.value)}
              className="w-full"
            />
            <div className="flex gap-2">
              <Button
                onClick={handleCustomInsert}
                className="flex-1 text-sm"
                disabled={!customVariable?.trim()}
              >
                Add
              </Button>
              <Button
                onClick={() => {
                  setShowCustom(false);
                  setCustomVariable('');
                }}
                variant="secondary"
                className="flex-1 text-sm"
              >
                Cancel
              </Button>
            </div>
          </div>
        ) : (
          <Button
            onClick={() => setShowCustom(true)}
            variant="secondary"
            className="w-full flex items-center justify-center gap-2 text-sm"
          >
            <Plus className="w-4 h-4" />
            Custom Variable
          </Button>
        )}
      </div>
      <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-xs text-blue-700">
          Click a variable to copy it to clipboard, then paste it into your template content
        </p>
      </div>
    </div>
  );
}